import { useEffect } from 'react';
import { localStorageService } from 'common/utilities/LocalStorageService';

export const useBreakOnFirstRender = () => {
  useEffect(() => {
    if (localStorageService.getItem('breakOnFirstRender') === 'true') {
      // eslint-disable-next-line no-debugger
      debugger;
    }
  }, []);
};
